import styled from 'styled-components';

import DocumentPhoto from '~components/svgs/DocumentPhoto';
import { Check, Text } from '~components';

export const Header = styled.section`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing.km6};
`;

export const DocumentPhotoSvg = styled(DocumentPhoto)`
  margin-top: ${({ theme }) => theme.spacing.km16};
  margin-bottom: ${({ theme }) => theme.spacing.km6};
`;

export const LegendText = styled(Text)`
  margin-top: ${({ theme }) => theme.spacing.km8};
`;

export const EmptyFooter = styled.footer`
  display: flex;
  justify-content: center;
  align-items: center;

  border-top: 1px solid ${({ theme }) => theme.color.border.neutral.default};
  margin: 0 -${({ theme }) => theme.spacing.km6};
  margin-top: auto;
  margin-bottom: -${({ theme }) => theme.spacing.km6};
  min-height: 80px;
`;

export const CheckIcon = styled(Check)`
  display: inline-block;
  color: ${({ theme }) => theme.color.icon.success.default};
`;
